import { GenericQueryParamsType } from '../types';
import { FareToSaveType, FareType } from '../typesFinancial';
import { tosApi } from './tosApi';
import { getInvalidatesTags, TagType } from './utils';

export type ChargeGenericQueryParamsType = GenericQueryParamsType;

// A coluna de faturamento do relatório de atracações mostra o status derivado das
// tarifas da cobrança, mas vem de uma query de Stopover -- então toda mutation que
// muda status ou o conjunto de tarifas precisa invalidar as duas tags.
const CHARGE_STATUS_TAGS = (chargeId?: number): TagType[] => [
  { type: 'Charge', code: chargeId },
  { type: 'Stopover', code: '5' },
];

export const FareApi = tosApi.injectEndpoints({
  endpoints: (build) => ({
    createFare: build.mutation<FareType, FareToSaveType>({
      query: (fare) => ({
        url: '/financial/fare',
        method: 'POST',
        body: fare,
      }),
      invalidatesTags: (_result, error, queryArgs) =>
        getInvalidatesTags(error, CHARGE_STATUS_TAGS(queryArgs.charge_id)),
    }),
    updateFare: build.mutation<FareType, FareToSaveType>({
      query: (fare) => ({
        url: `/financial/fare/${fare.id}`,
        method: 'PUT',
        body: fare,
      }),
      invalidatesTags: (_result, error, queryArgs) =>
        getInvalidatesTags(error, [
          { type: 'Charge', code: queryArgs.charge_id },
        ]),
    }),
    deleteFare: build.mutation<void, number>({
      query: (id) => ({
        url: `/financial/fare/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, error, queryArgs) =>
        getInvalidatesTags(error, CHARGE_STATUS_TAGS(queryArgs)),
    }),
    apportion: build.mutation<
      FareType,
      { chargeId: number; items: FareToSaveType[] }
    >({
      query: (fares) => ({
        url: `/financial/fare/apportions`,
        method: 'PUT',
        body: fares.items,
      }),
      invalidatesTags: (_result, error, queryArgs) =>
        getInvalidatesTags(error, [
          { type: 'Charge', code: queryArgs.chargeId },
        ]),
    }),
    patchFare: build.mutation<
      FareType,
      {
        id: number;
        chargeId: number;
        action: 'generate_statement' | 'cancel_statement' | 'archive_statement';
        // Só o envio informa. O estorno e o arquivamento seguem sem corpo.
        isSubstitution?: boolean;
      }
    >({
      query: (params) => ({
        url: `/financial/fare/${params.id}/${params.action}`,
        method: 'PATCH',
        body:
          params.isSubstitution === undefined
            ? undefined
            : { is_substitution: params.isSubstitution },
      }),
      invalidatesTags: (_result, error, queryArgs) =>
        getInvalidatesTags(error, CHARGE_STATUS_TAGS(queryArgs.chargeId)),
    }),
  }),
  overrideExisting: true,
});

export const {
  useCreateFareMutation,
  useUpdateFareMutation,
  useDeleteFareMutation,
  useApportionMutation,
  usePatchFareMutation,
} = FareApi;
